import { IEventResultData } from "common/records/EventResult";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_EVENT_RESULT = "@eventResults/RECEIVE_EVENT_RESULT";
export const RECEIVE_EVENT_RESULTS = "@eventResults/RECEIVE_EVENT_RESULTS";

export const EventResultActions = {
  receiveEventResult: (result: IEventResultData) => createAction(RECEIVE_EVENT_RESULT, { result }),
  receiveEventResults: (results: IEventResultData[]) => createAction(RECEIVE_EVENT_RESULTS, { results }),
};

export type EventResultActions = ActionsUnion<typeof EventResultActions>;
